<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/config/orderNumber/rule/template/page" getKey="rows"
			:columns="columns" @expandChange="expandChange">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('danjumingcheng')">
						<yi_dictionary_select :type="'DOCUMENT_TYPE'" :ids.sync="yt.conditions.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary" v-if="ids == null">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/config/orderNumber/rule/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('danjumingcheng')" required="required">
						<yi_dictionary_select :type="'DOCUMENT_TYPE'" :ids.sync="yt.editObj.type">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('qianzhui')" required="required">
						<el-input v-model="yt.editObj.prefix"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shijiangeshi')" required="required">
						<el-select :popper-append-to-body="false" filterable :clearable="true"
							v-model="yt.editObj.dateTimeFormat">
							<el-option v-for="item in timeFormatList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zizengweishu')" required="required">
						<yi_number_input :type="'number'" :min="1" :value="1" :start.sync="yt.editObj.increment"></yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('suijiweishu')" required="required">
						<yi_number_input :type="'number'" :min="0" :start.sync="yt.editObj.random"></yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select filterable :clearable="true" v-model="yt.editObj.enable">
							<el-option v-for="(item, index) in status" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4}">
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/orderNumber/rule/template/create', null, fetchData)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('danjumingcheng')" required="required">
						<yi_dictionary_select :type="'DOCUMENT_TYPE'" :ids.sync="yt.editObj.type" disabled="true">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('qianzhui')" required="required">
						<el-input v-model="yt.editObj.prefix"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shijiangeshi')" required="required">
						<el-select :popper-append-to-body="false" filterable :clearable="true"
							v-model="yt.editObj.dateTimeFormat">
							<el-option v-for="item in timeFormatList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('zizengweishu')" required="required">
						<yi_number_input :type="'number'" :min="1" :start.sync="yt.editObj.increment"></yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('suijiweishu')" required="required">
						<yi_number_input :type="'number'" :min="0" :start.sync="yt.editObj.random"></yi_number_input>
					</el-form-item>
					<el-form-item :label="$t('shifouqiyong')" required="required">
						<el-select filterable :clearable="true" v-model="yt.editObj.enable">
							<el-option v-for="(item, index) in status" :key="index" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('beizhu')">
						<el-input v-model="yt.editObj.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4}">
						</el-input>
					</el-form-item>
					
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/orderNumber/rule/template/update', null, fetchData)"
						type="primary">{{$t('baocun')}}
					</el-button>

				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	
	export default {
		name: 'admin_data_template_order_rule_list',
		
		data() {
			return {
				list: [],
				timeFormatList: [{
					value: 'yyyyMMdd',
					label: 'yyyyMMdd'
				}, {
					value: 'yyyyMM',
					label: 'yyyyMM'
				}],
				status: [{
						label: this.$t("shi"),
						value: true
					},
					{
						label: this.$t("fou"),
						value: false
					}
				],
				columns: [{
					label: 'danjubianma',
					prop: 'code',
					width: 130
				}, {
					label: 'danjumingcheng',
					prop: 'type',
					key: 'DOCUMENT_TYPE',
					type: 'dictionary',
					width: 230
				}, {
					label: 'qianzhui',
					prop: 'prefix'
				}, {
					label: 'shijiangeshi',
					prop: 'dateTimeFormat'
				}, {
					label: 'zizengweishu',
					prop: 'increment'
				},{
					label: 'suijiweishu',
					prop: 'random'
				}, {
					label: 'shifouqiyong',
					prop: 'enable',
					type: 'bool'
				}, {
					label: 'beizhu',
					prop: 'remarks'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 130,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.get(1)
			}, 300)
			this.getList()
		},
		methods: {
			// 获取列表数据
			async getList() {
				let response = await this.http.get('/web/equipment/fault/template/page', {
					platform: 1,
					pageNum: 1,
					pageSize: 1000
				})
				console.log("list",response.data.rows)
				this.list = response.data.rows
			},
			// 重置
			clear() {
				this.get(1)
			},

		}
	};
</script>
